import React, { useEffect, useState } from "react";
import { match,useHistory } from "react-router-dom";
import {
    Snackbar
    , Dialog
    , DialogTitle
    , DialogContent
    , DialogContentText
    , TextField
    , DialogActions
    , Button
    , Grid
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useDispatch } from "react-redux";
import InfoDisplay from '../../../components/InfoDisplay/InfoDisplay';
import { AppMesages, ResponseObjectMesages } from "../../../constants/AppMesages.constants";
import { AuthenticationService } from "../../../services/AuthenticationService";
import { ResponseObject } from "../../../models/ResponseObject";
import { UserLoginState } from "../../../reducers/LoginReducer";
import { Common } from "../../../utils/Common";
import AllActions from "../../../actions";
import {
    InforDisplyaDuration,
    VendorRequestViewMode,
    NavigationPaths
  } from "../../../constants/AppConstants";
import vendorAuthStyles from './VendorAuthentication.css';
import translation from '../../../i18n/i18.json';
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
export interface RouterParmToken {
    token: string;
}

function VendorAuthentication({ match }: { match: match<RouterParmToken> }) {

    const classes = vendorAuthStyles();
    const history = useHistory();
    const dispatch = useDispatch();

    const [token, setToken] = useState("");
    const [showWarning, setShowWarning] = useState(false);
    const [warningMessage, setWarningMessage] = useState("");
    const [showDialog, setShowDialog] = useState(false);
    const [vendorId, setVendorId] = useState(0);
    const [pinCode, setPinCode] = useState("");
    const [showPinInput, setShowPinInput] = useState(true);
    useEffect(() => {
        //Get the token from URL
        var prmToken = match.params.token;
        if (prmToken === "" || prmToken === undefined) {
            //Show Error message
            setShowPinInput(false);
            setWarningMessage(AppMesages.WARNING_VENDOR_AUTHENTICATION_NOTOKEN);
            setShowWarning(true);
        }
        else {
            //Validate the token
            sendPin(prmToken);
        }
    }, [token]);

    const sendPin = (prmToken:string) => {
        AuthenticationService.validateVendorURLToken(prmToken, (respose: ResponseObject) => {
            if (respose.resposeObjectType == 2) {
                if (respose.message === ResponseObjectMesages.INVALID_TOKEN) {
                    setWarningMessage(AppMesages.WARNING_VENDOR_AUTHENTICATION_INVALID_TOKEN);
                    setShowWarning(true);
                } else if (respose.message === ResponseObjectMesages.TOKEN_EXPIRED) {
                    setWarningMessage(AppMesages.WARNING_VENDOR_AUTHENTICATION_TOKEN_EXPIRED);
                    setShowWarning(true);
                }
            }
            else if (respose.resposeObjectType == 1) {
                setVendorId(respose.result.vendorId);
                //Set UserLoginState
                const userProfileData = {
                    sapSystem: "",
                    userName: "",
                    email: "",
                    refreshToken: "",
                    accessToken: "",
                    isAuthenticated: false,
                    isVendor: false,
                    //roles: [],
                    errorMessage: "",
                    //appPointIds:[],
                    userCompanies:[],
                    userClusters:[]
                };
                userProfileData.email = respose.result.email;
                userProfileData.accessToken = respose.result.accessToken;
                userProfileData.refreshToken = respose.result.refreshToken;
                Common.setLoginUserData(userProfileData);
                //Show the popup to enter pin
                setShowDialog(true);
            }
        },
        (error) => {

        });
    }    

    const handleWarningAlertClose = () => {
        setShowWarning(false);
    }
    const handleDialogClose = () => {
        setShowDialog(false);
    }
    const handleResendPin = () => {
        sendPin(match.params.token);
    }
    const handlePinChange = (evnt: any) => {
        setPinCode(evnt.target.value);
    }
    const handleValidatePin = () => {
        if(pinCode && pinCode.trim()){
            AuthenticationService.validateVendorPinCode(pinCode, (respose: ResponseObject) => {
                if (respose.resposeObjectType === 1) {
                    Common.setLoginUserData(respose.result);
                    //Navigate to Vendor Detail
                    history.push(NavigationPaths.VendorDetail, 
                        {vendorId: respose.result.userId,
                        requestId: respose.result.userId,
                        mode: VendorRequestViewMode.VendorCreate
                        });
                    setShowDialog(false);
                } else {
                    dispatch(AllActions.infoActions.openInforError(translation.vendor_auth_pin_invalid, InforDisplyaDuration.common));
                }
            },
            (error) => { });
        } else{
            dispatch(AllActions.infoActions.openInforError(translation.vendor_auth_pin_required, InforDisplyaDuration.common));
        }
    }
    return <div><div className={classes.logInPage}>

        <div className={classes.signInWrapper}>
            <Grid container component="main" className={classes.root}>


                <div className={classes.loginContentWrapper}>

                    <div className={classes.logoWrapper}>
                        <div className={classes.loginPageLogo} /></div>

                    <div className={classes.loginDataRowOne}>
                        <span className={classes.TxtOne}>Hello!</span>
                        <span className={classes.TxtTwo}>Welcome to <b>Vendor Onboarding!</b></span>




                        {/* <Grid item xs={12} sm={12} md={12} lg={12} className={classes.loginDataRowThree}>
           <span className={classes.TxtTree}>Time Study App</span>
           </Grid> */}


                        {/* <div className={classes.loginBtn}>
             <Button onClick={handleSignIn1}>Login Test</Button>
           </div>  */}
                        {showPinInput &&
                            <div className={classes.loginBtn}>
                                <span>{translation.vendor_auth_display}</span>
                                {/* <TextField
                                    autoFocus
                                    margin="dense"
                                    id="pinCode"
                                    label="Pin Code"
                                    type="number"
                                    value={pinCode}
                                    onChange={handlePinChange}
                                /><div className={classes.loginBtn}>
                                    <Button onClick={handleValidatePin}>Validate</Button>
                                </div> */}
                            </div>
                        }
                    </div>
                </div>

            </Grid>
        </div>;
    </div>;
        <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            autoHideDuration={10000}
            open={showWarning}
            ContentProps={{
                'aria-describedby': 'message-id',
            }}
            message={<span id="message-id"> Warning </span>}
            onClose={handleWarningAlertClose}>
            <Alert severity="warning">
                {warningMessage}
            </Alert>
        </Snackbar>
        <Dialog open={showDialog} onClose={handleDialogClose} aria-labelledby="form-dialog-title">
            <DialogTitle  className={classes.popUpHeader} id="form-dialog-title">Enter PIN Code</DialogTitle>
            <DialogContent className={classes.NoPopWrapper} >

                <DialogContentText>
                <span className={classes.popUpLBL}>  Please enter the PIN Code send to you through a SMS</span>
          </DialogContentText>
          <div className={classes.inputWrapper}>
                <TextField
                    autoFocus
                    margin="dense"
                    id="pinCode"
                    type="number"
                    value={pinCode}
                    onChange={handlePinChange}
                />
            </div>
            </DialogContent>
            <DialogActions> 
                <div style={{ margin:"20px ​10px 15px 0"}}>
                    <div className={classes.greenBtnWrapper}>
                        <Button onClick={handleValidatePin} color="primary">
                            <CheckCircleIcon></CheckCircleIcon>
                            {"Confirm"}
                        </Button>
                    </div>
                    <div className={classes.greenBtnWrapper}>
                        <Button onClick={handleResendPin} color="primary">
                            <CheckCircleIcon></CheckCircleIcon>
                            {"Resend"}
                        </Button>
                    </div>
                    <div className={classes.grayBtnWrapper}>
                        <Button onClick={handleDialogClose} color="primary" autoFocus>
                        {"Cancel"}
                        </Button>
                    </div>
                </div>
            </DialogActions>
        </Dialog>
        <InfoDisplay></InfoDisplay>
    </div>
}

export default VendorAuthentication;